<!--  -->
<template>
    <div class="studyTheList">
        <p class="title">学习榜单排名</p>
        <div class="list" v-if="!loading">
            <div class="item" v-for="(item, index) in list" :key="index">
                <div class="sort_img_name">
                    <div class="sort">
                        <img v-if="index === 0" :src="require('@/common/images/special/first.png')" alt="">
                        <img v-else-if="index === 1" :src="require('@/common/images/special/second.png')" alt="">
                        <img v-else-if="index === 2" :src="require('@/common/images/special/third.png')" alt="">
                        <span v-else>{{index+1}}</span>
                    </div>
                    <div class="img">
                        <img v-if="item.customerheadurl" :src="item.customerheadurl" alt="">
                        <img v-else :src="require('@/common/images/special/user.png')" alt="">
                    </div>
                    <div class="name" :class="{'top_three': index < 3}">{{item.customername}}</div>
                </div>
                <div class="count">{{item.paperfinishcount}}道</div>
            </div>
        </div>
        <skeleton type='listcom' v-else active :options="{row: 10, lineHight: 40}" />
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    data() {
        return {

        }
    },
    props: ['list', 'loading'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {

    },
    computed: {
        ...mapGetters([
            'user'
        ])
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
    .studyTheList {
        height: 506px;
        padding: 20px 15px;
        background: url('../../../../common/images/special/bg3.png');
        background-size: 100% 506px;
        box-sizing: border-box;
        .title {
            text-align: center;
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 15px;
            font-weight: bold;
        }
        .list {
            .item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                &:not(:last-of-type) {
                    margin-bottom: 12px;
                }
                .sort_img_name {
                    display: flex;
                    align-items: center;
                    .sort {
                        width: 24px;
                        text-align: center;
                        color: #999999;
                        font-size: 12px;
                        margin-right: 10px;
                        img {
                            width: 24px;
                            height: 16px;
                        }
                    }
                    .img {
                        width: 32px;
                        height: 32px;
                        margin-right: 6px;
                        img {
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                        }
                    }
                    .name {
                        font-size: 14px;
                        line-height: 20px;
                        &.top_three {
                            color: #E13B29;
                        }
                    }
                }
                .count {
                    font-size: 12px;
                    color: #999999;
                }
            }
        }
    }
</style>